module.exports = __webpack_public_path__ + "img/back.f2654300.svg";